import { StaticImage } from 'gatsby-plugin-image'
import React, { Component } from 'react'
import * as s from './BlueModule.module.css'
export default class BlueModule extends Component {
    render() {
        return (
            <div className={s.wrapper}>
                <h1 className={s.headline}>Auswertung</h1>
                <div className={s.container}>
                   <div className={s.submodule}>
                        <div className={s.subtitleModule}>
                            <StaticImage src="../../../images/information.svg" alt="information icon" className={s.icon}/>
                            <h2 >Information</h2>
                        </div>
                        <ol>
                            <li>Text mit Aufzählung</li>
                            <li>Text mit Aufzählung</li>
                            <li>Text mit Aufzählung</li>
                        </ol>
                   </div>
                   <div  className={s.submodule}>
                        <StaticImage src="../../../images/hand-smal.svg" alt="information icon" className={s.smallIcon}/>
                        <h2 className={s.text}>
                            Hinweis: Folgende informationsquellen und Anlaufstellen könnten - 
                            ohne Anspruch auf Vollständigkeit sowie ohne Gewähr - für Ihr Anliegen relevant sein.
                            Nach Anklicken eines Themas öffnet sich ein externer Link mit weiterführenden informationen in einem neuen Fenster.
                        </h2>
                   </div>
                   <div  className={s.submodule}>
                       <StaticImage src="../../../images/AAAAE56A2E5927E0.png" alt="information icon" className={s.smallerIcon}/>
                       <div className={s.text}>
                            <a className={s.text} href="https://www.ihk.de/themen/existenzgruendung/einstiegsinformationen"> https://www.ihk.de/themen/existenzgruendung/einstiegsinformationen</a> <br />
                            <a  className={s.text}  href="https://www.ihk.de/themen/existenzgruendung/sicherung">https://www.ihk.de/themen/existenzgruendung/sicherung</a> <br />
                            <a  className={s.text}  href="https://www.ihk.de/themen/existenzgruendung/einstiegsinformationen">https://www.ihk.de/themen/existenzgruendung/einstiegsinformationen</a>
                       </div>
                   </div>
                </div>
            </div>
        )
    }
}
